import { css } from "@emotion/react";
import { BOTTOM_NAVIGATE_HEIGHT } from "components/mobile/BottomNavigate/index.style";
import { HEADER_MOBILE_HEIGHT } from "components/mobile/MHeader/index.style";
import { theme } from "styles/theme";

export const DefaultLayoutStyle = {
  index: css`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-top: ${HEADER_MOBILE_HEIGHT};
    padding-bottom: ${BOTTOM_NAVIGATE_HEIGHT};

    background-color: ${theme.colors.black};
  `,

  image: css`
    img {
      width: 100vw;
      height: 100vh;
      object-fit: cover;
    }
  `,
  main: css`
    overflow: hidden;
    flex: 1;
  `,
};
